import { useOrganisation } from "../../../providers/OrganisationProvider";
import { MembershipsPageSkeleton } from "./MembershipsPageSkeleton";
import { Typography } from "@mui/material";
import { T } from "../../../util/t";
import { OpenMemberships } from "components/layout/organisation/OpenMemberships";

const MembershipsPage = () => {
    const organisation = useOrganisation();

    if (!organisation) return <MembershipsPageSkeleton />;

    return (
        <>
            <Typography variant="h7" component="h2" mb={2}><T>Memberships</T></Typography>
            <OpenMemberships series={organisation.series} federatedOrganisationTerm={organisation.federatedOrganisationTerm} defaultExpanded />
        </>
    );
};
export default MembershipsPage;
